import { HttpHeaders, HttpParams } from '@angular/common/http';

import { Aircraft } from '@core/model/entity/aircraft.model';
import { Customer } from '@core/model/customer/customer.model';
import { TrainingCenter } from '@core/model/entity/training-center.model';

export function stateToHttpParams(
  trainingCenters?: TrainingCenter[],
  trainingStartDate?: Date,
  aircraft?: Aircraft,
  customer?: Customer,
) {
  let params = new HttpParams();

  if (trainingStartDate) {
    params = params.append('startDate', trainingStartDate.toISOString());
  }

  if (trainingCenters && trainingCenters.length > 0) {
    for (const trainingCenter of trainingCenters) {
      params = params.append('trainingCenterId', trainingCenter.geminiSiteId);
    }
  }

  if (aircraft && aircraft.externalId) {
    params = params.append('aircraftId', aircraft.externalId);
  }
  if (customer && customer.salesForceId) {
    params = params.append('customerId', customer.salesForceId);
  }

  return params;
}

export function addToHttpParams(httpParams: HttpParams, value: unknown, key?: string): HttpParams {
  if (typeof value === 'object' && value !== null && !(value instanceof Date)) {
    httpParams = addToHttpParamsRecursive(httpParams, value);
  } else {
    httpParams = addToHttpParamsRecursive(httpParams, value, key);
  }
  return httpParams;
}

export function addToHttpParamsRecursive(
  httpParams: HttpParams,
  value?: unknown,
  key?: string,
): HttpParams {
  if (value == null) {
    return httpParams;
  }

  if (Array.isArray(value)) {
    value.forEach((element: unknown) => {
      httpParams = addToHttpParamsRecursive(httpParams, element, key);
    });
  } else if (value instanceof Date) {
    if (key != null) {
      httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
    } else {
      throw Error('key may not be null if value is Date');
    }
  } else if (typeof value === 'object') {
    const record = value as Record<string, unknown>;
    Object.keys(record).forEach((property) => {
      httpParams = addToHttpParamsRecursive(
        httpParams,
        record[property],
        key != null ? `${key}.${property}` : property,
      );
    });
  } else if (key != null) {
    httpParams = httpParams.append(key, String(value));
  } else {
    throw Error('key may not be null if value is not object or array');
  }
  return httpParams;
}

export function addOptionsToHttpHeaders(
  headers: HttpHeaders,
  options?: {
    headerAccept?: string;
    headerContentType?: string;
  },
) {
  if (options) {
    if (options.headerAccept) {
      headers = headers.set('Accept', options.headerAccept);
    }
    if (options.headerAccept) {
      headers = headers.set('Content-Type', options.headerContentType);
    }
  }
  return headers;
}

/**
 * @param consumes string[] mime-types
 * @return true: consumes contains 'multipart/form-data', false: otherwise
 */
export function canConsumeForm(consumes: string[]): boolean {
  const form = 'multipart/form-data';
  for (const consume of consumes) {
    if (form === consume) {
      return true;
    }
  }
  return false;
}
